import { LucideIcon } from 'components/LucideIcon'
import { Box } from 'designSystem/components/Box'
import { DropdownMenuContent } from 'designSystem/components/DropdownMenu'
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from 'designSystem/components/Sidebar'
import { StyledDropdownMenuTrigger } from 'features/navbar'
import React from 'react'
import styled from 'styled-components'

import {
  DROPDOWN_CONTENT_STYLE,
  NotificationsDropdownBase,
} from './NotificationsDropdownBase'
import { NotificationsDropdownContent } from './NotificationsDropdownContent'

const SidebarNotificationBadge = styled.span`
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  height: 1rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background-color: ${({ theme }) =>
    theme.forecast.danger ?? theme.common.alert.error};
  color: white;
  font-size: 0.625rem;
  font-weight: 600;
`

export const NotificationsDropdownSidebar: React.FC = () => (
  <NotificationsDropdownBase
    renderTrigger={({
      isOpen,
      arePlatformNotificationsEnabled,
      unreadCount,
    }) => (
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={isOpen} variant='embedded'>
          <StyledDropdownMenuTrigger
            type='button'
            aria-label='Open notifications'>
            <Box
              display='inlineFlex'
              shrink={false}
              style={{ position: 'relative' }}>
              <LucideIcon name='Bell' />
              {arePlatformNotificationsEnabled && unreadCount > 0 && (
                <SidebarNotificationBadge>
                  {unreadCount}
                </SidebarNotificationBadge>
              )}
            </Box>
            <span>Notifications</span>
          </StyledDropdownMenuTrigger>
        </SidebarMenuButton>
      </SidebarMenuItem>
    )}
    renderContent={(contentProps) => (
      <DropdownMenuContent
        side='right'
        sideOffset={12}
        align='end'
        style={DROPDOWN_CONTENT_STYLE}>
        <NotificationsDropdownContent {...contentProps} />
      </DropdownMenuContent>
    )}
  />
)
